import { Loader2 } from 'lucide-react';
import React from 'react';
import styles from './ApiReferencePanel.module.css';

export const ApiReferenceLoadingState: React.FC = () => (
  <p className={styles.status}>
    <Loader2 aria-hidden="true" />
    Loading your API reference…
  </p>
);
